<aside
  class="left-sidebar"
  [ngClass]="[showMinisidebar ? 'mini-sidebar' : '']">
  <!-- Sidebar scroll -->
  <div class="scroll-sidebar">
    <div class="sidebar-flip">
      <xm-sidebar
        data-cy="nav-sidebar"
        [menuItems]="sidebarMenuItems$ | async"
        [showMinisidebar]="showMinisidebar"
        (subItemSelected)="navigate($event)"
        (itemSelected)="navigate($event)">
        <!-- Static HREF links coded here are projected into the sidebar -->
      </xm-sidebar>
    </div>
  </div>
  <!-- End Sidebar scroll -->
</aside>
